import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {IonInfiniteScroll, ModalController} from "@ionic/angular";
import {Company} from "../../../../../../framework/model/core/company/company";
import {AppUser} from "../../../../../../framework/model/core/appuser/appuser";
import {OrderService} from "../../../../../services/OrderService";
import {ModelProvider} from "../../../../../../framework/providers/modelProvider/ModelProvider";
import {Events} from "../../../../../../framework/providers/events";
import {ModelToolsProvider} from "../../../../../../framework/providers/model-tools/model-tools";
import {AppSettings} from "../../../../../conf/appSettings";
import {
    CompanyService,
    CompanyServiceOptions,
    MiniCompany,
    StorageData,
    SyncLogEntry,
} from "../../../../../services/CompanyService";
import {AppDataService} from "../../../../../services/AppDataService";

@Component({
    selector: 'app-agent-companies',
    templateUrl: './agent-companies.page.html',
    styleUrls: ['./agent-companies.page.scss'],
})
export class AgentCompaniesPage implements OnInit {

    public appuser: AppUser;
    public models: Array<MiniCompany> = [];
    public prefix: string = 'companiesList'// + Math.floor(Math.random() * Math.floor(1000000));

    @Input()
    public options: object = {'ready': false};

    public filters: object = {'limit': 20, 'offset': 0, 'setPrefix': true};
    public fields = ['companyFileNumber', 'internalCompanyId', 'city', 'street'];

    public modelId;
    public settings;


    public storageData: StorageData;
    public storageOptions: CompanyServiceOptions;
    public showSyncLog: boolean = false;
    public syncLog: SyncLogEntry[] = [];

    public searchText;
    public modelsCount;

    @ViewChild(IonInfiniteScroll, null) ioninfiniteScroll: IonInfiniteScroll;

    constructor(public modalController: ModalController, public orderService: OrderService, public modelProvider: ModelProvider, public appdataService: AppDataService,
                public events: Events, public modelTools: ModelToolsProvider, public appSettings: AppSettings, public companyService: CompanyService) {
        this.appuser = this.orderService.getAppUser();
        this.settings = this.appSettings.getSettings('app');
        this.modelId = this.appuser.data.companyId;

        if (this.settings['clients_page_fields'])
            this.fields = this.settings['clients_page_fields']
    }

    ngOnInit() {
        this.options['useCache'] = true//!this.orderService.getNetworkState()['status']
        this.options['refresh-button'] = true//!this.orderService.getNetworkState()['status']

        this.storageOptions = this.companyService.getOptions();
        this.storageData = this.companyService.getStorageData();
        this.loadCompanies();

    }

    loadCompanies(init = true, e = null, forceList = false): void {
        if (forceList) {
            delete this.filters['search'];
            this.filters['offset'] = 0;
        }

        if (!this.models.length) {
            this.models = this.companyService.getInitModels();
            if (this.models) {
                this.storageData = this.companyService.getStorageData();
                return
            }
        }

        this.companyService.getCompanies(this.filters, forceList).subscribe({
            next: (res) => {
                if (init)
                    this.models = res['models'];
                else {
                    this.models = this.models.concat(res['models']);
                }
                // this.options['ready'] = true;
                // this.modelsCount = res['modelsCount'];
                this.storageData = this.companyService.getStorageData();

                if (e)
                    e.target.complete();
            },
            error: (error) => {
                console.error('There was an error!', error);

                if (e)
                    e.target.complete();
            }

        });
    }

    search() {
        this.filters['offset'] = 0;
        this.filters['search'] = this.searchText;
        this.loadCompanies()
    }


    nextPage(e) {
        if (this.models.length >= this.storageData.modelsCount) {
            this.ioninfiniteScroll.disabled = true;
            return;
        }

        let limit = this.filters['limit'];

        this.filters['limit'] = 20;
        if (!this.filters['offset']) this.filters['offset'] = 0;
        this.filters['offset'] += limit;

        // this.loadCompanies(false, e);

        this.companyService.nextPage(this.filters).subscribe(
            {
                next: (data) => {
                    this.models = this.models.concat(data['models']);

                    if (e)
                        e.target.complete();
                },
                error: (error) => {
                    console.error('Error fetching next page of models:', error);

                }
            });
    }


    changeCompany(e) {
        let companyId = e['detail']['value'];
        ////console.loge);
        ////console.logcompanyId);
        let company = this.modelProvider.getModelById(this.models, companyId);
        //console.logcompany);

        this.modelId = company.data.id;
        this.orderService.changeAgentCompany(company);

        // this.appuser.data.companyId = comapny.data.id;
        // this.appuser.data.companyName = comapny.data.companyName;
        // this.appuser.data.companyFileNumber = comapny.data.companyFileNumber;
        // this.appuser.data.companyStatus = comapny.data.status;
        // this.appuser.data.internalCompanyId = comapny.data.internalCompanyId;
        // this.appuser.data.companyApproved = comapny.data.approved;
        // this.appuser.data.companyPriceApproved = comapny.data.priceApproved;
        //
        // this.modelProvider.update(this.appuser, {}, null, true).then((res) => {
        //     this.events.publish('agentCompanyChanged');
        // })
    }

    viewClient(model) {
        if (this.appuser.data.companyId == model.data.id) {
            this.goToClient(model);
            return;
        }

        let me = this;

        if (this.settings['agent_changeClient_yesOrNoAlert_disabled']) {
            me.changeClient(model)
            me.modelTools.presentToast(this.modelTools.getTranslate('connectingToClient') + '- ' + model.data.companyName)
        } else {
            this.modelTools.yesOrNoAlert(function () {
                me.changeClient(model)
            }, {'title': this.modelTools.getTranslate('connectingToClient'), 'message': model.data.companyName});
        }
    }

    changeClient(model) {
        this.setCient(model)
    }

    async setCient(minimodel) {
        let prefix: string = 'company_' + Math.floor(Math.random() * Math.floor(1000000));
        this.companyService.getMiniCompany(minimodel.data.id).then((model) => {
            if(!model) model = minimodel;

            this.goToClient(model);

            // this.modelProvider.loading();
            if (model.data.prices_data) {
                let params = {'prefix': prefix, 'date': model.data.prices_last_sync, 'disable_prices_list': true}
                this.appdataService.agentCompanyChanged(params, model.data.prices_data)
            }


            this.events.subscribe(prefix, (res) => {
                this.modelProvider.loadingOff();
                this.events.unsubscribe(prefix, 'agent-companies')
            }, 'agent-companies')

            this.orderService.changeAgentCompany(model, null, false, prefix);
        })
    }

    goToClient(model) {
        let page = 'client-page/' + model.data.id + '/1'
        if (this.settings['connect_to_client_init_page'])
            page = this.settings['connect_to_client_init_page']
        console.log("GOO!!")
        this.modelTools.goTo(page)
    }

    toggleSyncLog() {
        this.showSyncLog = !this.showSyncLog;
        if (this.showSyncLog) {
            this.syncLog = this.companyService.getSyncLog();
        }
    }

    close() {
        this.modalController.dismiss();
    }

}
